import { render, staticRenderFns } from "./ActivityConfig.vue?vue&type=template&id=57978d61&scoped=true&"
import script from "./ActivityConfig.vue?vue&type=script&lang=js&"
export * from "./ActivityConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57978d61",
  null
  
)

export default component.exports